

























import { Component, Vue } from 'vue-property-decorator';
import { GQL_applicationUserData_currentUser } from '@/queries/__generated__/applicationUserData';
import { SmartQuery } from 'vue-apollo-decorator';
import { APPLICATION_USER_DATA } from '@/queries/Application';
import { UNIT_SEARCH } from '@/queries/Unit';
import gql from 'graphql-tag';
import { GQL_requestAccessToUnit } from '@/queries/__generated__/requestAccessToUnit';

const REQUEST_ACCESS_TO_UNIT = gql`
  mutation requestAccessToUnit($unitId: ID!) {
    requestAccessToUnit(input: { unitId: $unitId }) {
      unit { id name }
    }
  }
`;

@Component
export default class RequestAccessToUnit extends Vue {
  @SmartQuery(APPLICATION_USER_DATA) public currentUser!: GQL_applicationUserData_currentUser;

  private UNIT_SEARCH = UNIT_SEARCH;
  private REQUEST_ACCESS_TO_UNIT = REQUEST_ACCESS_TO_UNIT;
  private selectedUnitId: string | null = null;
  private today = this.$dayjs().format('YYYY-MM-DD');

  private requestAccessToUnit() {
    return this.$apollo
      .mutate<GQL_requestAccessToUnit>({
        mutation: REQUEST_ACCESS_TO_UNIT,
        variables: {
          unitId: this.selectedUnitId,
        },
      })
      .then(response => {
        this.$sMessage.success(
          this.$t(
            'Unit.successfulyRequestedAccess',
            {company: response.data!.requestAccessToUnit!.unit!.name},
          ),
        );
        this.$emit('request-successful');
      });
  }
}
